<script lang="ts">
  import { onDestroy } from 'svelte';

  import GlanceIcon from '$lib/assets/icons/GlanceIcon.svelte';
  import MysitesIcon from '$lib/assets/icons/MysitesIcon.svelte';
  import { CATEGORY_NAVBAR_DROPDOWN, type DrawerNavbarType } from '$lib/constants/navbar';
  import { POLICIES } from '$lib/constants/policy';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames } from '$lib/types/analytics';
  import type { Policy } from '$lib/types/policies';
  import { SiteProvider } from '$lib/types/siteProvider';

  import { redirectTo } from '$lib/utils';
  import CrossIcon from '../assets/icons/CrossIcon.svelte';
  import Accordian from './Shared/Accordian.svelte';

  export let categories: DrawerNavbarType[];
  export let showSideDrawer = false;
  export let source: string;
  let showClosingAnimation = false;

  const toggleSideBar = () => (showClosingAnimation = true);

  const onMenuClick = (menuName: string) => {
    sendAnalyticsEvent(EventNames.MENU_CATEGORY_CLICK, { menu_name: menuName });
    showClosingAnimation = true;
  };

  $: if (showSideDrawer) document.body.style.overflow = 'hidden';

  onDestroy(() => (document.body.style.overflow = 'auto'));

  const sortByRank = (a: Policy, b: Policy) => a.rank - b.rank;

  const filteredPolicies = POLICIES.sort(sortByRank).filter((policy) => policy.enabled);
  // Move the About Mysites to the top of the drawer for now, can be changed later
  const drawerCategories = [
    ...filteredPolicies.slice(0, 1),
    ...categories,
    ...filteredPolicies.slice(1)
  ];
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="mask-view"
  on:click={toggleSideBar}
  class:fadeIn={!showClosingAnimation}
  class:fadeOut={showClosingAnimation}
/>
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="container"
  class:slideIn={!showClosingAnimation}
  class:slideOut={showClosingAnimation}
  on:click={() => {
    if (showClosingAnimation) showSideDrawer = !showSideDrawer;
  }}
>
  <header class="header">
    {#if source == SiteProvider.TRACFONE}
      <MysitesIcon />
    {:else}
      <GlanceIcon />
    {/if}
    <button class="cross-btn" on:click={toggleSideBar}>
      <CrossIcon />
    </button>
  </header>
  <ul class="list-items">
    {#each drawerCategories as drawer (drawer.name)}
      <li class="main-list">
        {#if drawer.dropdown}
          <Accordian opacity="1" fontWeight="var(--font-weight-semibold)">
            <svelte:fragment slot="head">
              <span>
                {drawer.name}
              </span>
            </svelte:fragment>
            <svelte:fragment slot="content">
              <div class="drop-down-list">
                {#each CATEGORY_NAVBAR_DROPDOWN[drawer.name] as dropdownItem}
                  <div
                    on:click={() => {
                      redirectTo(dropdownItem.href);
                      onMenuClick(dropdownItem.name);
                    }}
                  >
                    {dropdownItem.name}
                  </div>
                {/each}
              </div>
            </svelte:fragment>
          </Accordian>
        {:else}
          <a href={drawer.path} on:click={() => onMenuClick(drawer.name)}>
            {drawer.name}
          </a>
        {/if}
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.7;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 0.7;
    }
    to {
      opacity: 0;
    }
  }

  .mask-view {
    position: fixed;
    border: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: var(--z-index-drawer);
    background-color: var(--color-page-background);
  }

  .fadeIn {
    animation: fadeIn 0.5s forwards;
  }

  .fadeOut {
    animation: fadeOut 0.5s forwards;
  }

  .container {
    background: var(--color-card-background);
    height: 100vh;
    width: 85%;
    max-width: 408px;
    z-index: var(--z-index-drawer);
    position: fixed;
    top: 0;
    right: 0;
    padding-left: 26px;
    padding-right: 12px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .slideIn {
    animation: slideIn 0.5s ease-in-out;
  }

  .slideOut {
    animation: slideOut 0.5s ease-in-out;
  }

  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cross-btn {
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
  }

  .drop-down-list {
    margin-left: 6px;
    border: 0;
    div {
      padding: 8px 0;
      color: var(--color-drawer-text);
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-normal);
      line-height: 140%;
    }
  }

  .list-items {
    padding: 4px 0 0 0;
    list-style: none;
    li {
      font-size: var(--font-size-base);
      font-weight: var(--font-weight-semibold);
      border-bottom: 1px solid #ffffff1a;
      a {
        text-decoration: none;
        color: var(--color-drawer-text);
        display: flex;
        padding: 16px 0;
      }
    }
  }
</style>
